import React, { useEffect } from 'react'

function TrustPilot({ templateId, height, subHeader, displayWidgetOnly = false}) {
  const useScript = url => {
    useEffect(() => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      }
    }, [url]);
  };

  useScript('https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js')

  return (
    <div className="trustpilot-container text-center">
      {!displayWidgetOnly &&
        <div>
          <h3 className='header'>See what our customers say</h3> 
          <p className='m-5 sub-header'>{subHeader}</p>
        </div>
      }
      <div 
        id="trustpilot-slider"
        className="trustpilot-widget"
        data-locale="en-US" 
        data-template-id={templateId}
        data-businessunit-id="5e17bdbb6a6fea0001d2b3fb" 
        data-style-height={height}
        data-style-width="100%" 
        data-theme="light" 
        data-stars="4,5" 
        data-review-languages="en"
      >
        <a href="https://www.trustpilot.com/review/yard.com.au" target="_blank" rel="noopener">Trustpilot</a>
      </div>

      {!displayWidgetOnly &&
        <div className="text-center mt-5 mb-3">
          <a className="green bigger see-all-text" href="https://au.trustpilot.com/review/yard.com.au"><b>See all reviews</b></a>
        </div>
      }
    </div>
  )
}

export default TrustPilot;
